import axios from 'axios';

const config = {};

export async function loadConfig() {
  if (process.env.NODE_ENV === 'development') {
    const envKey = process.env.REACT_APP_ENV.toUpperCase();
    const json = await import(`./environments/${envKey}.json`);
    Object.assign(config, {
      ...json,
      [envKey]: true,
    });
  } else {
    const resp = await axios.get('/config/env.json');
    Object.assign(config, resp.data);
  }
}

export default new Proxy(config, {
  get(target, name) {
    return target[name] ?? false;
  },
});
